// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"1d7e83a6","42":"dd8e4e40","165":"0a4498f9","388":"2a9147c5","412":"06f3e7f0","463":"8b733cef","608":"b7f54d2b","699":"99919317","753":"c99d0b0b"}[chunkId] + ".chunk.js";
};